import type { FC } from "react";

import { Heading, TopBar } from "src/components";
import { Routes } from "src/routes";
import { useTranslation } from "src/translations";
import { getValOrThrowError } from "src/utils";
import { PaymentInstructions, PayoutTransferDetailsLoader } from "../components";

export const OrderPayInfoPage: FC = () => {
    const orderDocumentId = getValOrThrowError(Routes.orderPayInfo.useParams().orderDocumentId, "Missing Order Document Id");
    const { t } = useTranslation();

    return (
        <>
            <div className="sticky top-0 bg-brand-white">
                <TopBar />
            </div>
            <div className="mx-auto mb-10 grid w-full max-w-lg gap-6 px-4">
                <Heading level={1} className="my-8 text-center">
                    {t("orders.pay.transferDetails.title")}
                </Heading>
                <PayoutTransferDetailsLoader orderDocumentId={orderDocumentId} />
                <PaymentInstructions />
            </div>
        </>
    );
};
